export default "__VITE_ASSET__ZDx7xR95__"